<template>
  <div>
    <page-title
      heading="Manajemen Tarif"
      :breadcrumb="[
        {
          label: 'Manajemen Tarif',
          link: '/manajemen-tarif'
        },
        {
          label: 'List Tarif',
          active: true
        }
      ]"
      class="layout-gantung ninja-shadow"
    />

    <div class="container-fluid">
      <div class="card card-box mb-3 ninja-shadow">
        <div class="card-body __list-manajemen-tarif">
          <div class="col-md-12 mb-3" v-if="hasFeatures('edit_tarif')">
            <div class="media">
              <div class="media-left align-self-center">
                <b-form-checkbox v-model="checkboxAll"></b-form-checkbox>
              </div>
              <div class="media-content align-self-center">
                <b-dropdown size="sm" variant="outline-dark">
                  <b-dropdown-item @click="checkboxAll = true">
                    All
                  </b-dropdown-item>
                  <b-dropdown-item @click="checkboxAll = false">
                    None
                  </b-dropdown-item>
                </b-dropdown>
              </div>
            </div>
          </div>
          <div class="col-md-12 no-padding">
            <DataTableWrapper
              :perPage="perPage"
              :fromPage="fromPage"
              :toPage="toPage"
              :totalEntries="totalEntries"
              :currentPage="currentPage"
              :callbackFunc="fetchListTarif"
              @valueChanged="handleValueChanged"
            >
              <template v-slot:right-header>
                <b-button
                  variant="danger"
                  class="text-uppercase align-self-end mr-2"
                  @click="downloadTarif()"
                  v-if="hasFeatures('download_tarif')"
                  ><font-awesome-icon icon="download" /> DOWNLOAD DATA</b-button
                >
                <b-button
                  variant="success"
                  v-if="hasFeatures('upload_tarif')"
                  class="text-uppercase align-self-end mr-2"
                  :to="{
                    name: 'upload-manajemen-tarif'
                  }"
                >
                  <font-awesome-icon icon="upload" /> UPLOAD DATA</b-button
                >
                <b-button
                  variant="primary"
                  v-if="hasFeatures('tambah_tarif')"
                  class="text-uppercase align-self-end "
                  :to="{
                    name: 'manajemen-tarif-tambah'
                  }"
                  >tambah tarif</b-button
                >
              </template>
              <b-table
                :items="tarifList"
                :fields="fieldList"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                 thead-tr-class="izd-datatable"
                :no-local-sorting="true"
              >
                <template v-slot:head()="data">
                  {{ data.label }}
                  <b-input
                    size="sm"
                    class="mt-2 w-95"
                    v-if="data.field.searchable"
                    @input="searchValueChanged($event, data.field.key)"
                  />
                </template>

                <template v-slot:cell(id)="data">
                  <b-form-checkbox
                    v-if="hasFeatures('edit_tarif')"
                    v-model="checkboxTarif"
                    :value="data.item.id"
                    class="text-center"
                  ></b-form-checkbox>
                </template>

                <template v-slot:cell(tarif)="data">
                  {{ data.value }}
                </template>

                <template v-slot:head(action)="data" >
                  <strong :style="hasFeatures('tambah_tarif') ? '' : 'display:none;'" 
                    class="mt-2"
                    >{{ data.label }}</strong
                  >
                </template>

                <template v-slot:head(poliklinik)="data">
                  {{data.label}}
                  
                  <template>
                    <multiselect
                      class="__multi-select-tarif mt-2"
                      v-model="selectedPoli"
                      placeholder="Pilih Poli"
                      :options="optionPoli"
                      :multiple="true"
                      label="label"
                      @input="clearPoli($event)"
                      open-direction="bottom"
                      track-by="label"
                      selectLabel="Pilih Poli"
                      deselectLabel="Batalkan"
                      selectedLabel="Terpilih"
                      :preselect-first="true"
                      :close-on-select="true"
                      :clear-on-select="true"
                    >
                      <template slot="selection" slot-scope="{ values, isOpen }"
                        ><span
                          class="multiselect__single"
                          v-if="values.length &amp;&amp; !isOpen"
                          >{{ values.length }} Poli Terpilih</span
                        ></template
                      >
                    </multiselect>
                  </template>
                </template>

                <template v-slot:head(kategori)="data">
                  {{ data.label }}
                  <template>
                    <vue-select-clearable
                      :options="optionKategori"
                      v-model="selectedKategori"
                      @input="clearKategori($event)"
                      class="custom-v-select-manajemen-tarif mt-2"
                      style="width:100%;background-color:#ffffff;"
                    >
                      <template slot="option" slot-scope="option">
                        {{ option.label }}
                      </template>
                      <template slot="selected-option" slot-scope="option">
                        {{ option.label }}
                      </template>
                    </vue-select-clearable>
                  </template>
                </template>

                <template
                  v-slot:cell(action)="data"
                  v-if="hasFeatures('edit_tarif')"
                >
                  <span
                    class="d-flex align-items-center justify-content-between"
                  >
                    <b-dropdown
                      id="dropdown-1"
                      class="m-md-2 text-capitalize"
                      variant="primary"
                      size="sm"
                      right
                    >
                      <template v-slot:button-content>
                        <font-awesome-icon icon="copy" />
                      </template>
                      <b-dropdown-item @click="editModal(data.item)">
                        Edit Data
                      </b-dropdown-item>
                      <b-dropdown-item
                        @click="
                          removeTarif({
                            id: data.item.id,
                            nama_layanan: data.item.nama_layanan
                          })
                        "
                      >
                        Hapus Data
                      </b-dropdown-item>
                    </b-dropdown>
                  </span>
                </template>
                <template v-slot:cell(last_modified)="data">
                    <label style="font-size:12px;">
                        {{ data.item.updated.at }} <br>
                        by <b>{{ data.item.updated.by }}</b>
                    </label>
                </template>
              </b-table>
            </DataTableWrapper>
          </div>
        </div>
      </div>
    </div>
    <!-- MODAL -->
    <b-modal
      ref="modal-edit"
      :hide-footer="true"
      size="xl"
      centered
      no-close-on-esc
      no-close-on-backdrop
      @hide="resetModal"
    >
      <template #modal-header class="__modal-manajemen-edit">
        <h5>Ubah Tarif</h5>
      </template>
      <div class="card shadow-none border-0">
        <div class="card-body">
          <form role="form">
            <div class="form-row">
              <div class="form-group col-xs-12 col-lg-2">
                <strong>Poli<span style="color:red">*</span></strong>
                <vue-select
                  class="mt-2"
                  :options="optionPoli"
                  v-model="editData.poliklinik"
                  @input="cekPoli(data)"
                />
                <template v-if="editData.poliklinik === ''">
                  <b-form-invalid-feedback
                    :force-show="true"
                    class="text-capitalize"
                  >
                    Poli harus di isi
                  </b-form-invalid-feedback>
                </template>
              </div>
              <div class="form-group col-xs-12 col-lg-2">
                <strong>Kategori<span style="color:red">*</span></strong>
                <vue-select
                  class="mt-2"
                  :options="optionKategori"
                  v-model="editData.kategori"
                  @input="cekKategori(data)"
                />
                <template v-if="editData.kategori === ''">
                  <b-form-invalid-feedback
                    :force-show="true"
                    class="text-capitalize"
                  >
                    Kategori harus di isi
                  </b-form-invalid-feedback>
                </template>
              </div>
              <div class="form-group col-xs-12 col-lg-4">
                <strong>Nama Layanan<span style="color:red">*</span></strong>
                <input
                  type="text"
                  class="form-control mt-2"
                  id="nm_layanan"
                  maxlength="100"
                  v-model="editData.nama_layanan"
                  @input="setNameLayanan($event.target.value)"
                  @keypress="onKeypressNamaLayanan"
                  :class="isError('nama_layanan')"
                  :disabled="editData.priority === 1"
                />
                <template v-if="editData.nama_layanan === ''">
                  <b-form-invalid-feedback
                    :force-show="true"
                    class="text-capitalize"
                  >
                    Nama layanan harus di isi
                  </b-form-invalid-feedback>
                </template>
                <template v-else-if="getErrorValidation('nama_layanan')">
                  <b-form-invalid-feedback
                    :force-show="true"
                    class="text-capitalize"
                  >
                    {{ getErrorValidation("nama_layanan") }}
                  </b-form-invalid-feedback>
                </template>
              </div>
              <div class="form-group col-xs-12 col-lg-2">
                <strong>Kode Layanan<span style="color:red">*</span></strong>
                <input
                  type="text"
                  class="form-control mt-2"
                  maxlength="10"
                  v-model.trim="editData.kode_layanan"
                  @input="onInputCode($event)"
                  @keypress="onKeypressKodeLayanan"
                  :class="isError('kode_layanan')"
                />
                <template
                  v-if="
                    (editData.kode_layanan &&
                      editData.kode_layanan.trim() === '') ||
                      !editData.kode_layanan
                  "
                >
                  <small style="font-size:13px;color:red;"
                    >Kode layanan harus di isi</small
                  >
                </template>
                <template v-else-if="getErrorValidation('kode_layanan')">
                  <b-form-invalid-feedback
                    :force-show="true"
                    class="text-capitalize"
                  >
                    {{ getErrorValidation("kode_layanan") }}
                  </b-form-invalid-feedback>
                </template>
                <template v-if="this.checkDataKode == 1"> </template>
                <template
                  v-if="
                    this.checkDataKode == 2 &&
                      $v.kode_layanan.$params &&
                      $v.kode_layanan.$params.required
                  "
                >
                  <div class="error" style="font-size:13px;">
                    Kode Layanan Sudah Ada
                  </div>
                </template>
              </div>
              <div class="form-group col-xs-12 col-lg-2">
                <strong>Tarif<span style="color:red">*</span></strong>
                <b-input-group class="mt-2">
                   <template #prepend>
                    <b-input-group-text  style="width:25px" ><span style="margin-left:-10px">Rp.</span> </b-input-group-text>
                  </template>
                  <b-form-input
                    v-model.lazy="editData.tarif"
                    v-money="money"
                    validated="true"
                    maxlength="19"
                    class="text-right"
                  >
                  </b-form-input>
                </b-input-group>
              </div>
              <div class="form-group col-md-12 col-lg-12">
                <b-button
                  variant="primary"
                  class="float-right"
                  @click="updateTarif(editData)"
                  >Simpan
                </b-button>
                <b-button
                  variant="danger"
                  @click="closeModal()"
                  class="float-right mr-3"
                  >Keluar
                </b-button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import startCase from "lodash/startCase";
import { library } from "@fortawesome/fontawesome-svg-core";
import debounce from "lodash/debounce";
import { replace as rep, differenceWith as dw, isEqual as iE } from "lodash";

import {
  required,
  minLength,
  maxLength,
  sameAs,
  email,
  numeric
} from "vuelidate/lib/validators";

import {
  faArrowRight,
  faArrowUp,
  faTrashAlt,
  faSearch,
  faPencilAlt,
  faUpload,
  faDownload,
  faCopy
} from "@fortawesome/free-solid-svg-icons";

import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

import { VMoney } from "v-money";
import accounting from "accounting";
import moment from "moment";
moment.locale("id");

library.add(
  faArrowRight,
  faDownload,
  faUpload,
  faArrowUp,
  faTrashAlt,
  faSearch,
  faPencilAlt,
  faCopy
);

import { mapGetters } from "vuex";
import Multiselect from "vue-multiselect";

export default {
  components: {
    Multiselect,
    "font-awesome-icon": FontAwesomeIcon,
    DataTableWrapper: () => import("../../components/DataTableWrapper"),
    "vue-select": () => import("@/components/VueSelect.vue"),
    "vue-select-clearable": () => import("@/components/VueSelectClearable.vue")
  },
  directives: {
    money: VMoney
  },
  data() {
    return {
      selectedKategori: null,
      selectedPoli: null,
      checkboxTarif: [],
      isCheckedAll: false,
      checkboxAll: false,
      showAllFilter: true,
      selectedFilter: "all",
      tarifs: [],
      money: {
        decimal: "",
        thousands: ",",
        prefix: "",
        suffix: " ",
        precision: 0
      },
      currentPage: 1,
      rows: 100,
      perPage: 10,
      tarifList: [],
      namaLayanan: "",
      kodeList: [],
      nama_layanan: "",
      kode_layanan: "",
      tarif: "",
      kodeLayananBeforeEdit: "",
      kodeTarif: "",
      editmode: false,
      checkDataKode: 1,
      editData: {
        id: null,
        kode_layanan: null,
        nama_layanan: null,
        tarif: null,
        priority: null
      },
      shallowCopyEditData: null,
      beingSubmit: false,
      errors: [],
      fromPage: 0,
      toPage: 0,
      totalEntries: 0,
      sortBy: "",
      sortDesc: false,
      searchValue: [],
      validationError: Object(),
      optionPoli: [],
      optionKategori: []
    };
  },
  computed: {
    ...mapGetters(["getKlinikId", "getRolesName"]),
    fieldList() {
       const {
        generateFieldList: g,
        setSearchableAndSortableFieldList: s
      } = this;
      const r = val => Boolean(/(id|action|checklist|last_modified)\b/gi.test(val) ? !1 : 1);
      return (
        [
          { key: "id", label: "" },
          {
            key: "poliklinik",
            label: "poli",
            thStyle: "width:20%;"
          },
          {
            key: "kategori",
            label: "kategori",
            thStyle: "width:15%;"
          },
          {
            key: "nama_layanan"
          },
          {
            key: "kode_layanan",
            label: "kode layanan",
            thStyle: "width:13%;"
          },
          {
            key: "tarif",
            label: "tarif",
            class: "tarif-pre-whitespace",
            thStyle: "width:5%;"
          },
          {
            key: "action"
          },
          { key: "last_modified", label: "last modified" },
        ]
        |> (v => s({ field: v, customFunc: r }))
        |> (z => g({ field: z }))
      );
    }
  },
  watch: {
    currentPage() {
      this.fetchListTarif();
    },
    perPage() {
      this.fetchListTarif();
    },
    sortBy() {
      this.fetchListTarif();
    },
    sortDesc() {
      this.fetchListTarif();
    },
    searchValue: {
      handler: "fetchListTarif",
      deep: true
    },
    checkboxAll() {
      if (this.checkboxAll) this.allChecked();
      else this.checkboxTarif = this.tarifs = [];
    },
    selectedFilter() {
      this.fetchListTarif();
      if (this.selectedFilter == "all") this.variantAll = "outline-primary";
      else this.variantAll = "outline-dark";
    },
    selectedKategori() {
      this.fetchListTarif();
    },
    selectedPoli() {
      this.fetchListTarif();
    }
  },
  validations: {
    editData: {
      kode_layanan: {
        required,
        maxLength: maxLength(5)
      },
      nama_layanan: {
        required,
        minLength: minLength(2),
        maxLength: maxLength(50)
      },
      tarif: {
        required,
        numeric,
        maxLength: maxLength(12)
      }
    }
  },
  mounted() {
    this.getKategori();
    this.getPoli();
  },
  methods: {
    clearKategori(data) {
      if (data == null) {
        this.fetchListTarif();
      }
    },
    clearPoli(data) {
      if (data.length == 0) {
        this.fetchListTarif();
      }
    },
    hasFeatures(value) {
      const features = {
        tambah_tarif: ["pic_cabang"],
        edit_tarif: ["pic_cabang"],
        delete_tarif: ["pic_cabang"],
        upload_tarif: ["pic_cabang", "frontdesk", "kasir"],
        download_tarif: ["pic_cabang"]
      };

      const isOwner = features[value].filter(feature => {
        return this.getRolesName.includes(feature);
      });

      return isOwner.length > 0 ? true : false;
    },
    allChecked() {
      let checked = [];
      this.tarifList.forEach(x => {
        checked.push(x.id);
        this.tarifs.push({ id: x.id });
      });
      this.checkboxTarif = [...new Set(checked)];
    },
    async cekPoli(data) {
      const key = "nama_layanan";
      const key1 = "kode_layanan";
      try {
        let poli_id = this.editData.poliklinik.value || 'all'
        const res = await this.$axios.get(
          `layanan/cek?id=${this.editData.id}&klinik_id=${this.getKlinikId}&poli_id=${poli_id}&kategori_id=${this.editData.kategori.value}&nama_layanan=${this.editData.nama_layanan}&kode_layanan=${this.editData.kode_layanan}`
        );
        const { status, data } = res.data;
        if (!status) {
          this.validationError = {
            ...this.validationError,
            [key]: "nama layanan tidak boleh sama",
            [key1]: "kode layanan tidak boleh sama"
          };
        } else {
          this.resetValidationError(key);
          this.resetValidationError(key1);
        }
      } catch (error) {}
    },
    async cekKategori(data) {
      const key = "nama_layanan";
      const key1 = "kode_layanan";
      try {
        const res = await this.$axios.get(
          `layanan/cek?id=${this.editData.id}&klinik_id=${this.getKlinikId}&poli_id=${this.editData.poliklinik.value}&kategori_id=${this.editData.kategori.value}&nama_layanan=${this.editData.nama_layanan}&kode_layanan=${this.editData.kode_layanan}`
        );
        const { status, data } = res.data;
        if (!status) {
          this.validationError = {
            ...this.validationError,
            [key]: "nama layanan tidak boleh sama",
            [key1]: "kode layanan tidak boleh sama"
          };
        } else {
          this.resetValidationError(key);
          this.resetValidationError(key1);
        }
      } catch (error) {}
    },
    closeModal() {
      if (!this.beingSubmit && localStorage.getItem("IDLE") != 1) {
        this.$swal({
          title: startCase("keluar"),
          html: `Apakah Anda yakin untuk keluar dari halaman tarif?<br>Data yang telah ditulis tidak akan tersimpan.`,
          type: "warning",
          showCancelButton: true,
          cancelButtonText: startCase("Tidak"),
          confirmButtonText: startCase("Ya")
        }).then(res => {
          if (res.value) {
            this.resetModal();
            this.editData = null;
            this.kodeLayananBeforeEdit = null;
            this.$refs["modal-edit"].hide();
          } else {
            next(false);
          }
        });
      } else {
        next();
      }
    },
    async getPoli() {
      try {
        const res = await this.$axios.get(
          `layanan/poli?klinik_id=${this.getKlinikId}&with_all_poli=1`
        );
        const { data, status } = res.data;
        if (status) {
          this.optionPoli = data.map(res => ({
            ...res,
            label: res.nama,
            value: res.id
          }));
        }
      } catch (error) {}
    },
    async getKategori() {
      try {
        const res = await this.$axios.get(
          `layanan/kategori?klinik_id=${this.getKlinikId}`
        );
        const { data, status } = res.data;
        if (status) {
          this.optionKategori = data.map(res => ({
            ...res,
            label: res.nama,
            value: res.id
          }));
        }
      } catch (error) {}
    },
    resetModal() {
      const { validationError } = this;
      const x = Object.keys(validationError);
      x.map(item => {
        this.validationError[item] = null;
      });
    },
    isError(key) {
      if (key) {
        const { validationError } = this;
        const { [key]: tmp } = validationError;

        return (
          (tmp && (!tmp ? { "is-valid": true } : { "is-invalid": true })) ||
          null
        );
      } else {
        return null;
      }
    },
    getErrorValidation(key) {
      return this.validationError[key];
    },
    handleValueChanged({ perPage, currentPage }) {
      perPage && (perPage |> (_ => (this.perPage = _)));
      currentPage && (currentPage |> (_ => (this.currentPage = _)));
    },
    searchValueChanged: debounce(function(val, key) {
      const { searchValue } = this;

      const z = searchValue.filter(item => item.key !== key);
      this.searchValue = [
        ...z,
        {
          key,
          value: val
        }
      ];
    }, 500),
    onKeypressNamaLayanan($event) {
      const {
        key,
        target: { value }
      } = $event;
      var evt = $event;
      evt = evt ? evt : window.event;
      if (
        /[^a-zA-Z0-9\-\ \(\)\/\.]/.test(key) ||
        (value && value.trim().length >= 50)
      ) {
        evt.preventDefault();
      } else {
        return evt;
      }
    },
    onKeypressKodeLayanan($event) {
      const {
        key,
        target: { value }
      } = $event;
      var evt = $event;
      evt = evt ? evt : window.event;
      if (/[^a-zA-Z0-9\-]/.test(key) || (value && value.trim().length >= 20)) {
        evt.preventDefault();
      } else {
        return evt;
      }
    },
    resetValidationError(key) {
      if (key) {
        const x = (this.validationError[key] = null);
      }
    },
    async validateNamaLayanan(val) {
      const key = "nama_layanan";
      const key1 = "kode_layanan";
      try {
        let poli_id = this.editData.poliklinik.value || 'all'
        const res = await this.$axios.get(
          `layanan/cek?id=${this.editData.id}&klinik_id=${this.getKlinikId}&poli_id=${poli_id}&kategori_id=${this.editData.kategori.value}&nama_layanan=${val}&kode_layanan=${this.editData.kode_layanan}`
        );
        const { status, data } = res.data;
        if (!status) {
          this.validationError = {
            ...this.validationError,
            [key]: "nama layanan tidak boleh sama",
            // [key1]: "kode layanan tidak boleh sama"
          };
        } else {
          this.resetValidationError(key);
          this.resetValidationError(key1);
        }
      } catch (err) {
        this.resetValidationError(key);
      }
    },
    async validateKodeLayanan(val) {
      const key = "kode_layanan";
      const key1 = "nama_layanan";
      try {
        let poli_id = this.editData.poliklinik.value || 'all'
        const res = await this.$axios.get(
          `layanan/cek?id=${this.editData.id}&klinik_id=${this.getKlinikId}&poli_id=${poli_id}&kategori_id=${this.editData.kategori.value}&nama_layanan=${this.editData.nama_layanan}&kode_layanan=${val}`
        );
        const { status, data } = res.data;
        if (!status) {
          this.validationError = {
            ...this.validationError,
            [key]: "kode layanan tidak boleh sama",
            // [key1]: "nama layanan tidak boleh sama"
          };
        } else {
          this.resetValidationError(key);
          this.resetValidationError(key1);
        }
      } catch (err) {
        this.resetValidationError(key);
      }
    },
    onInputCode: debounce(function($event) {
      const {
        target: { value }
      } = $event;
      const key = "kode_layanan";
      const {
        shallowCopyEditData: { [key]: a }
      } = this;

      this.editData.kode_layanan = value.toUpperCase();
      // this.checkDataKode = 1;

      if (value && value !== a) {
        this.validateKodeLayanan(value);
      } else {
        this.resetValidationError(key);
      }
    }, 600),
    setNameLayanan: debounce(function(value) {
      const key = "nama_layanan";
      const {
        shallowCopyEditData: { [key]: a }
      } = this;
      this[key] = value;
      if (value && value !== a) {
        this.validateNamaLayanan(value);
      } else {
        this.resetValidationError(key);
      }
    }, 600),
    removeTarif({ id, nama_layanan = null } = {}) {
      this.$swal({
        text: `Apakah Anda yakin ingin menghapus data tarif ${nama_layanan}?`,
        type: "question",
        showCancelButton: true,
        cancelButtonText: startCase("Tidak"),
        confirmButtonText: startCase("Ya"),
        confirmButtonColor: "#1791EE"
      }).then(async res => {
        if (res.value) {
          await this.deleteTarif(id);
        }
      });
    },
    async editModal(val) {
      try {
        const res = await this.$axios.get(
          `layanan/${val.id}?klinik_id=${this.getKlinikId}`
        );
        const { data } = res.data;

        const x = {
          id: data.id,
          poliklinik: data.poliklinik,
          kategori: data.kategori,
          kode_layanan: data.kode_layanan,
          nama_layanan: data.nama_layanan,
          tarif: data.tarif
        };

        this.shallowCopyEditData = Object.assign({}, x);
        this.editData = x;
        this.kodeLayananBeforeEdit = data.kode_layanan;
        this.checkDataKode = 1;
        this.getKategori();
        this.getPoli();
        this.$refs["modal-edit"].show();
      } catch (error) {}
    },
    async updateTarif(dataEdit) {
      const { shallowCopyEditData, validationError } = this;
      const { tarif: scTarif } = shallowCopyEditData;
      const { nama_layanan, tarif } = dataEdit;

      if (
        validationError &&
        Object.keys(validationError).every(val => !validationError[val])
      ) {
        const conv = val => rep(val, /[^0-9]/gi, "");
        const tmp = {
          ...dataEdit,
          tarif: conv(tarif)
        };
        const x = {
          ...shallowCopyEditData,
          tarif: conv(scTarif)
        };
        let z = [];
        const v = Object.keys(tmp).map(val => {
          if (x[val] !== tmp[val]) {
            z = [...z, val];
          }
        });

        if (
          tmp.kode_layanan == "" ||
          tmp.nama_layanan == "" ||
          tmp.tarif == ""
        ) {
          this.$swal({
            text: `Silakan lengkapi kolom yang harus diisi!`,
            type: "warning",
            showCancelButton: false,
            confirmButtonText: "OK",
            scrollbarPadding: false
          });
        } else {
          if (z.length > 0) {
            this.updateProsesTarif(dataEdit);
          } else {
            this.updateProsesTarif(dataEdit);
          }
        }
      }
    },
    async updateProsesTarif(dataEdit) {
      try {
        dataEdit.tarif = parseInt(dataEdit.tarif.replace(/\D/g, ""));
    
        let datanya = {
          klinik_id: this.getKlinikId,
          kategori_id: dataEdit.kategori.value,
          poli_id: dataEdit.poliklinik.value || 'all',
          tarif: dataEdit.tarif,
          nama_layanan: dataEdit.nama_layanan,
          kode_layanan: dataEdit.kode_layanan
        };

        const res = await this.$axios.put(
          `layanan/${dataEdit.id}`,
          datanya
        );
        const { status, data } = res.data;
      } catch (err) {

      } finally {
        this.$refs["modal-edit"].hide();
        this.$swal({
          title: "Edit Tarif Berhasil",
          text: "Data berhasil tersimpan",
          type: "success",
          confirmButtonText: startCase("ya")
        });
        this.fetchListTarif();
      }
    },
    async deleteTarif(id) {
      try {
        const res = await this.$axios.delete(`layanan/${id}?klinik_id=${this.getKlinikId}`);
        const { status, data } = res.data;
        if (status) {
          this.$swal({
            type: "success",
            title: startCase("deleted"),
            text: startCase("Tarif berhasil di hapus")
          });
          this.fetchListTarif();
        } else if (res.data.message === "Data tarif minimal 2") {
          this.$swal({
            type: "error",
            title: startCase("gagal"),
            text: startCase(
              "Tidak dapat menghapus tarif & layanan jika sudah mencapai batas minimal 2 layanan!"
            )
          });
        } else {
          this.$swal({
            type: "error",
            title: startCase("gagal"),
            text: startCase("Tarif gagal di hapus")
          });
        }
      } catch (err) {
        this.$swal({
          type: "error",
          title: startCase("gagal"),
          text: startCase("Tarif gagal di hapus")
        });
      }
    },
    determineParameter() {
      const { searchValue, sortBy, sortDesc } = this;
      let v = "";

      if (this.selectedFilter != "all") {
        v += `&branch_id=${this.selectedFilter}`;
      }

      if (this.selectedKategori != null) {
        v += `&kategori[0]=${this.selectedKategori.value}`;
      }

      if (this.selectedPoli != null) {
        for (let index = 0; index < this.selectedPoli.length; index++) {
          v += `&poliklinik[${index}]=${this.selectedPoli[index].value}`;
        }
      }

      searchValue.map(item => {
        const x =
          (false && item.key === "kode_layanan" && "nomor_layanan") || item.key;
        v += `&${x}=${item.value}`;
      });

      if (sortBy) {
        v += `&column=${sortBy}&order=${sortDesc ? "desc" : "asc"}`;
      }

      return v;
    },
    async fetchListTarif() {
      try {
        const res = await this.$axios.get(
          `layanan?klinik_id=${this.getKlinikId}&limit=${this.perPage}&page=${this.currentPage}${this.determineParameter()}`
        );
        const { status, data } = res.data;
        if (status) {

          const {
            data: tarifData,
            total: totalEntries,
            to: toPage,
            from: fromPage
          } = data;

          const x =
            tarifData.map(item => item.tarif)
            |> (_ => accounting.formatColumn(_, "Rp. ", 0, "."));

          this.tarifList = tarifData.map((item, key) => ({
            ...item,
            tarif: x[key],
            updated: {
              at: moment(item.updated.at).format("MMM DD, YYYY @ HH:mm"),
              by: item.updated.by
            }
          }));

          this.rows = totalEntries || 0;
          this.toPage = toPage || 0;
          this.fromPage = fromPage || 0;
          this.totalEntries = totalEntries;

          return this;
        }
      } catch (err) {
        
      }
    },
    async downloadTarif() {
      let arrId = this.checkboxTarif;

      const res = await this.$axios.post(`layanan/export`,{ id: arrId },);
      const { status, data } = res.data

      if(status) {
        let link = document.createElement("a")
        link.href = data.link
        link.setAttribute("download", data.name)
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        this.selectedId = [];
      } else {
        this.$swal({
          text: "Something went wrong",
          type: "error"
        })
      }
    }
  }
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style lang="scss">

.__list-manajemen-tarif {
  zoom: 80%;
}

.multiselect {
  &.__multi-select-tarif {
    min-height: auto !important;
    font-size: 12px !important;
    height: 31px !important;
    & > .multiselect__select {
      margin-top: -6px;
    }
    & > .multiselect__tags {
      height: 31px !important;
      min-height: 31px !important;
      padding: 2px 30px 0 6px;
    }
  }
}

.modal-backdrop {
  opacity: 0.5 !important;
}
.modal-header {
  background-color: #d3e8eb;
}
.izd-datatable-tarif {
  height: auto !important;
}
</style>

<style scoped lang="css">
.bg-kuning {
  background: #f7fc6b;
}

#kodetarif {
  text-transform: uppercase;
}

.modal fade show {
  opacity: 0.9;
}

.error {
  color: red;
}

.bg-kuning,
.bg-danger,
.bg-first {
  color: black !important;
}

.no-padding {
  padding: 0 !important;
}

.page-item.active a {
  background: #3b86ff;
  border: none !important;
}

.layout-gantung {
  border-radius: 0px 0px 10px 10px;
  max-height: 250px;
}

.ninja-shadow {
  box-shadow: 0px 8px 15px 0px lightgrey;
}

table thead tr.text-capitalize th {
  background: #dcecec;
}

table tbody tr.ganjil td {
  background: #f2f5f5;
}

table tbody tr.genap td {
  background: #e5ebea;
}
</style>
